import {useEffect, useState} from 'react';
import {useMasterAccountsQuery} from '../api/generated';
import {useAccessLevel} from './useAccessLevel';

const masterAccountsQuerySize = 20;

/**
 * This hook is used to fetch master accounts and load more master accounts when the user scrolls to the bottom of the list
 */
export const useMasterAccounts = () => {
  const {isAdmin} = useAccessLevel();

  const [selectOptions, setSelectOptions] = useState(
    [] as [{label: string; value: string}] | {label: string; value: string}[]
  );
  const [from, setFrom] = useState(masterAccountsQuerySize);
  const [loading, setLoading] = useState(true); // New state variable for loadingMore status

  const {data: masterAccountsData, fetchMore} = useMasterAccountsQuery({
    skip: !isAdmin,
    variables: {
      size: masterAccountsQuerySize,
      from: 0,
      filter: {}
    }
  });

  useEffect(() => {
    if (masterAccountsData) {
      setSelectOptions(
        masterAccountsData?.masterAccounts.items
          .map((ma) => ({
            label: ma.name as string,
            value: ma.id as string
          }))
          .sort((a, b) => {
            return (a.label ?? '').localeCompare(b.label ?? '');
          })
      );
      if (
        masterAccountsData.masterAccounts.items.length < masterAccountsData.masterAccounts.total
      ) {
        fetchMore({
          variables: {
            size: masterAccountsQuerySize,
            from
          },
          updateQuery: (prev, {fetchMoreResult}) => {
            if (!fetchMoreResult) return prev;
            if (fetchMoreResult.masterAccounts.total > masterAccountsQuerySize + from) {
              setFrom((prev) => prev + masterAccountsQuerySize);
            }
            return Object.assign({}, prev, {
              masterAccounts: {
                ...fetchMoreResult.masterAccounts,
                items: [...prev.masterAccounts.items, ...fetchMoreResult.masterAccounts.items]
              }
            });
          }
        });
      } else {
        setLoading(false); // Set loadingMore to false after fetchMore call
      }
    }
  }, [masterAccountsData]);

  return {selectOptions, loading};
};
